
function sideNavigation() {
	$(".menu-icon").click(function() {
		$(".side-nav-container").addClass('expanded-nav');
	})
	$(".close").click(function() {
		$(".side-nav-container").removeClass('expanded-nav');
	})
}

function fullModal() {
	$(".full-modal").click(function() {
		$(".full-modal").removeClass('in');
	})
}



function mobileNavigation() {
	$(".mobile-nav-icon").click(function() {
		$(".mobile-nav-container").addClass('expanded-nav');
	})
	$(".close").click(function() {
		$(".mobile-nav-container").removeClass('expanded-nav');
	})
}